export const SIGNUP_USERNAME_PATTERN = /^[a-z][a-z0-9_]{2,23}$/

export function normalizeSignupUsername(value: string): string {
  return value.trim().toLowerCase()
}

export function isValidSignupUsername(value: string): boolean {
  return SIGNUP_USERNAME_PATTERN.test(normalizeSignupUsername(value))
}
